import { __ENV__ } from 'awsApi'
import { ENVIRONMENTS_PREFIX, SERVICES } from '@wellbeingxltd/fe-lib/api/endpoints'

export const LOGIN = {
    NOT_LOGGED: 'NOT_LOGGED',
    START_LOGIN: 'START_LOGIN',
    LOGGED: 'LOGGED',
}

const PREFIX = ENVIRONMENTS_PREFIX[__ENV__]
export const URL = {
    ANALYTICS: {
        BASE: SERVICES.ANALYTICS[__ENV__],
        V3_ANALYTICS_USER_CREATE: PREFIX + '/v3/analytics/user/create',
    },
    APPRECIATION: {
        BASE: SERVICES.APPRECIATION[__ENV__],
        V6_APPRECIATION_GET_EMPLOYEE: PREFIX + '/v6/users/getActiveEmployees',
        V6_POST_APPRECIATION: PREFIX + '/v6/users/appreciation',
    },
    RECOMMENDER: {
        BASE: SERVICES.RECOMMENDER[__ENV__],
        V6_ANALYTICS_RECOMMENDED_RESOURCES_RETRIEVE: PREFIX + '/v6/users/recommendation',
    },
    CLIENTS: {
        BASE: SERVICES.CLIENTS[__ENV__],
        V3_CLIENTS_SETUP: PREFIX + '/v3/clients/setup',
    },
    DASHBOARD: {
        BASE: SERVICES.DASHBOARD[__ENV__],
        V4_DASHBOARD_RETRIEVE: PREFIX + '/v4/dashboard/retrieve',
        V4_DASHBOARD_TOP_RESOURCES: PREFIX + '/v4/dashboard/topResources',
    },
    DIRECTORY: {
        BASE: SERVICES.DIRECTORY[__ENV__],
        V3_DIRECTORY_LABELS_RETRIEVE: PREFIX + '/v3/directory/labels/retrieve',
        V3_DIRECTORY_SHARED_RETRIEVE: PREFIX + '/v3/directory/shared/retrieve',
        V3_DIRECTORY_USER_RETRIEVE: PREFIX + '/v3/directory/user/retrieve',
        V3_DIRECTORY_USER_RETRIEVE_ALL: PREFIX + '/v3/directory/user/retrieve/all',
    },
    EMAIL_SUPPORT: {
        BASE: SERVICES.EMAIL_SUPPORT[__ENV__],
        V2_EMAILSUPPORT_USER_OPENTICKET: PREFIX + '/v2/emailsupport/user/openticket',
        V2_EMAILSUPPORT_USER_GETTRANSACTIONS: PREFIX + '/v2/emailsupport/user/gettransactions',
        V2_EMAILSUPPORT_USER_CLOSETICKET: PREFIX + '/v2/emailsupport/user/closeticket',
    },
    RATINGS: {
        BASE: SERVICES.RATINGS[__ENV__],
        V3_RATINGS_USER_RETRIEVE: PREFIX + '/v3/ratings/user/retrieve',
        V3_RATINGS_USER_SUBMIT: PREFIX + '/v3/ratings/user/submit',
    },
    RESOURCES: {
        BASE: SERVICES.RESOURCES[__ENV__],
        V6_RESOURCES_USER_SEARCH_RETRIEVE: PREFIX + '/v6/resources/search',
    },
    REWARDS: {
        BASE: SERVICES.REWARDS[__ENV__],
        V6_POST_REWARD: PREFIX + '/v6/users/reward',
    },
    TRANSACTIONS: {
        BASE: SERVICES.TRANSACTIONS[__ENV__],
        V3_TRANSACTIONS_USER_CREATE: PREFIX + '/v3/transactions/user/create',
        V3_TRANSACTIONS_USER_RETRIEVE: PREFIX + '/v3/transactions/user/retrieve',
        V3_TRANSACTIONS_USER_UPDATE: PREFIX + '/v3/transactions/user/update',
        V3_TRANSACTIONS_USER_CANCEL: PREFIX + '/v3/transactions/user/cancel',
    },
    USER_PROFILES: {
        BASE: SERVICES.USER_PROFILES[__ENV__],
        V2_USERS_PROFILES_USER_GET_WELLBEING_SCORE: PREFIX + '/v2/usersProfiles/user/getWellbeingScore',
        V3_USERS_PROFILES_USER_FAVOURITE: PREFIX + '/v3/usersProfiles/user/favourite',
        V3_USERS_PROFILES_USER_GOAL: PREFIX + '/v3/usersProfiles/user/goal',
        V3_USERS_PROFILES_USER_RESET: '/v3/usersProfiles/user/reset',
        V3_USERS_PROFILES_USER_RETRIEVE: PREFIX + '/v3/usersProfiles/user/retrieve',
        V3_USERS_PROFILES_USER_UPDATE: PREFIX + '/v3/usersProfiles/user/update',
    },
    WELLBEING_ASSESSMENTS: {
        BASE: SERVICES.WELLBEING_ASSESSMENTS[__ENV__],
        V3_WELLBEING_ASSESSMENTS_USER_CREATE: PREFIX + '/v3/wellbeingAssessments/user/create',
        V3_WELLBEING_ASSESSMENTS_USER_RETRIEVE: PREFIX + '/v3/wellbeingAssessments/user/retrieve',
        V3_WELLBEING_ASSESSMENTS_WA_UPDATES_USER_CREATE: PREFIX + '/v3/wellbeingAssessments/waUpdates/user/create',
        V3_WELLBEING_ASSESSMENTS_WA_UPDATES_USER_RETRIEVE: PREFIX + '/v3/wellbeingAssessments/waUpdates/user/retrieve',
    },
}

export const OLD_URL = {
    V2_CLIENTS_SETUP: PREFIX + '/v2/clients/setup',
    PROFILE: {
        TEMPLATE_REQUEST_INVITATION: PREFIX + '/v2/usersProfiles/user/invitation',
    },
}
